import { UserPublic } from 'api/model';

export const getUserInitials = ({ display_name, username }: UserPublic): string => {
  const source = display_name.trim() || username;
  const parts = source.split(/\s+/).filter(Boolean);
  const initials = parts.length > 1 ? `${parts[0][0]}${parts[parts.length - 1][0]}` : source.slice(0, 2);
  return initials.toUpperCase();
};

export const getUserFirstName = ({ display_name, username }: UserPublic): string => {
  const source = display_name.trim() || username;
  return source.split(/\s+/)[0] || username;
};
